import axios from 'axios'
import { Message, Loading } from 'element-ui'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://8.162.11.120:3000', // 后端接口地址
  baseURL: 'https://www.aishangzhen.top', // 后端接口地址
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

// 请求取消令牌映射
const pendingMap = new Map()

// 生成请求唯一标识
const getRequestKey = (config) => {
  const { method, url, params, data } = config
  return [method, url, JSON.stringify(params), JSON.stringify(data)].join('&')
}

// 添加请求到pendingMap
const addPending = (config) => {
  const key = getRequestKey(config)
  if (!pendingMap.has(key)) {
    config.cancelToken = new axios.CancelToken(cancel => {
      pendingMap.set(key, cancel)
    })
  }
}

// 移除请求从pendingMap
const removePending = (config) => {
  const key = getRequestKey(config)
  if (pendingMap.has(key)) {
    const cancel = pendingMap.get(key)
    cancel('重复请求已取消')
    pendingMap.delete(key)
  }
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 取消重复请求
    removePending(config)
    addPending(config)
    
    // 在请求发送之前做一些处理
    // console.log('请求配置:', config)
    
    // 可以在这里添加token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    
    return config
  },
  error => {
    // 处理请求错误
    // console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 移除pending状态
    removePending(response.config)
    
    // 处理响应数据
    // console.log('响应数据:', response)
    
    const res = response.data
    
    // 根据后端接口规范统一处理
    if (!res.success) {
      // 业务错误处理
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      })
      
      // token过期或无效
      if (res.code === 401) {
        localStorage.removeItem('token')
        // 可以跳转到登录页
        // router.push('/login')
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    
    return res
  },
  error => {
    // 移除pending状态
    if (error.config) {
      removePending(error.config)
    }
    
    // 处理响应错误
    // console.error('响应错误:', error)
    
    // 请求被取消
    if (axios.isCancel(error)) {
    //   console.log('请求被取消:', error.message)
      return Promise.reject(error)
    }
    
    // 网络错误或超时
    Message({
      message: error.message || '网络异常，请稍后重试',
      type: 'error',
      duration: 3000
    })
    
    return Promise.reject(error)
  }
)

// 封装常用请求方法
const request = {
  get(url, params = {}, config = {}) {
    return service.get(url, {
      params,
      ...config
    })
  },
  
  post(url, data = {}, config = {}) {
    return service.post(url, data, config)
  },
  
  put(url, data = {}, config = {}) {
    return service.put(url, data, config)
  },
  
  delete(url, params = {}, config = {}) {
    return service.delete(url, {
      params,
      ...config
    })
  },
  
  patch(url, data = {}, config = {}) {
    return service.patch(url, data, config)
  }
}

export default request